import { defineMessages } from 'react-intl';

export default defineMessages({
	searchPlaceholder: {
		defaultMessage: 'Search...',
		description:
			'Placeholder for CMDB object picker field to advise the user to search for objects',
		id: 'cv.request.create.form.cmdbobjectpicker.search.new',
	},
	noOptions: {
		defaultMessage: 'No options',
		description:
			'Text that appears in the dropdown for the CMDB object picker if there are no objects to select',
		id: 'cv.request.create.form.cmdbobjectpicker.no.options',
	},
});
